/* eslint-disable */
import bi1_data_validation from '../base_i1_datavalidation'
import { RC, CR, AJRS } from '../base_i2_success_codes'
import base_i3_log from '../base_i3_logging'
import { ajax } from 'noquery-ajax'

function checkIfWatchdogUserExists(email, new_value) {
    return new Promise(function (resolve, reject) {
        var return_msg = "";
        var debug_data = [];
        var task_id = "p2s1t1-checkIfWatchdogUserExists"
        var return_value = null;

        ajax({
        url: window.G_ajax_test_domain + '/console/p2s1t1-check_if_user_exists',
        method: 'POST',
        dataType: "text",
        headers: {
            'Authorization': 'Bearer ' + G_firebase_auth.IV_id_token
        },
        data: { "user_email": email },
        success: function(result) {
            if (result.toLowerCase().indexOf('success') >= 0) {
                resolve(JSON.stringify({ success: RC.success, return_msg: return_msg, debug_data: debug_data }));
            } else if(result.toLowerCase().indexOf('unauthorized') >= 0) {
               window.G_firebase_auth.bi5forceTokenRefresh(false);
            } else {
                return_msg += "ajax request succeeded but payload indicates failure"
                debug_data.push(JSON.stringify(result));
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
                reject(JSON.stringify({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data }));
            }
        },
        error: function(error) {
            if (error.status === 401) {
                window.G_firebase_auth.bi5forceTokenRefresh();
            }
            return_msg += "ajax request failed"
            debug_data.push(JSON.stringify(error));
            reject(JSON.stringify({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data }));
        }
    })

});
};

export default checkIfWatchdogUserExists


// WEBPACK FOOTER //
// ./src/watchdog_includes/legacy_calls/p2s1t1_CheckIfUserExists.js